import React from 'react'

import WhatIsPassport from '../../components/WhatIsPassport'
import { useAppSelector } from '../../hooks/useStore'

function LearnMore() {
  const station = useAppSelector((state) => state.station)
  const stationDisplayName = station.short_common_name || ''
  const displayUrl = station.passport_learn_more_url
    ? station.passport_learn_more_url.replace('https://', '').replace('http://', '')
    : 'passport.pbs.org'

  return (
    <WhatIsPassport
      displayUrl={displayUrl}
      stationDisplayName={stationDisplayName}
    />
  )
}

export default LearnMore
